import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import styles from './price-breakdown-list.module.scss';

type PriceBreakdownListProps = PropsWithChildren & {
  className?: string;
};

export const PriceBreakdownList: React.FC<PriceBreakdownListProps> = ({ children, className }) => (
  <ul className={classNames(styles.list, className)}>{children}</ul>
);
